"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Entity_1 = require("./Entity");

var utils_1 = require("../utils");

var procedures_1 = require("../procedures");

var PolymathError_1 = require("../PolymathError");

var types_1 = require("../types");
/**
 * Check if the provided value is of type [[UniqueIdentifiers]]
 */


function isUniqueIdentifiers(identifiers) {
  var symbol = identifiers.symbol;
  return typeof symbol === 'string';
}
/**
 * Class used to manage all the Security Token Reservation functionality
 */


var SecurityTokenReservation =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(SecurityTokenReservation, _Entity_1$Entity);

  /**
   * Create a new SecurityTokenReservation instance
   */
  function SecurityTokenReservation(params, context) {
    var _this;

    _classCallCheck(this, SecurityTokenReservation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecurityTokenReservation).call(this));
    /**
     * Creates a security token with the reserved symbol
     *
     * @param name - name of the security token
     * @param detailsUrl - URL containing information about the security
     * @param divisible - whether the token should be divisible or not
     * @param treasuryWallet - address of a wallet to be used to store tokens for some operations (defaults to)
     */

    _this.createSecurityToken = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                procedure = new procedures_1.CreateSecurityToken(Object.assign({
                  symbol: this.symbol
                }, args), this.context);
                return _context.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Returns true if the Security Token associated to this reservation has already been launched
     */


    _this.isLaunched = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var context, symbol;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = this.context, symbol = this.symbol;
                return _context2.abrupt("return", context.contractWrappers.securityTokenRegistry.isTokenLaunched({
                  ticker: symbol
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Transfer the ownership of the ticker
     */


    _this.transferOwnership = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var context, symbol, newOwner, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = this.context, symbol = this.symbol;
                newOwner = args.newOwner;
                procedure = new procedures_1.TransferReservationOwnership({
                  symbol: symbol,
                  newOwner: newOwner
                }, context);
                return _context3.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    var symbol = params.symbol,
        expiry = params.expiry,
        reservedAt = params.reservedAt,
        securityTokenAddress = params.securityTokenAddress,
        ownerAddress = params.ownerAddress;
    _this.symbol = symbol;
    _this.context = context;
    _this.expiry = expiry;
    _this.reservedAt = reservedAt;
    _this.ownerAddress = ownerAddress;
    _this.securityTokenAddress = securityTokenAddress;
    _this.uid = SecurityTokenReservation.generateId({
      symbol: symbol
    });
    return _this;
  }
  /**
   * Generate the Security Token Reservation's UUID from its identifying properties
   */


  _createClass(SecurityTokenReservation, [{
    key: "toPojo",

    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */
    value: function toPojo() {
      var uid = this.uid,
          symbol = this.symbol,
          expiry = this.expiry,
          securityTokenAddress = this.securityTokenAddress,
          reservedAt = this.reservedAt,
          ownerAddress = this.ownerAddress;
      return {
        uid: uid,
        symbol: symbol,
        expiry: expiry,
        securityTokenAddress: securityTokenAddress,
        reservedAt: reservedAt,
        ownerAddress: ownerAddress
      };
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh(params) {
      var expiry = params.expiry,
          securityTokenAddress = params.securityTokenAddress,
          reservedAt = params.reservedAt,
          ownerAddress = params.ownerAddress;

      if (expiry) {
        this.expiry = expiry;
      }

      if (securityTokenAddress) {
        this.securityTokenAddress = securityTokenAddress;
      }

      if (reservedAt) {
        this.reservedAt = reservedAt;
      }

      if (ownerAddress) {
        this.ownerAddress = ownerAddress;
      }
    }
  }], [{
    key: "generateId",
    value: function generateId(_ref) {
      var symbol = _ref.symbol;
      return utils_1.serialize('securityTokenReservation', {
        symbol: symbol
      });
    }
    /**
     * Unserialize string to a Security Token Reservation object representation
     *
     * @param serialize - security token's serialized representation
     */

  }, {
    key: "unserialize",
    value: function unserialize(serialized) {
      var unserialized = utils_1.unserialize(serialized);

      if (!isUniqueIdentifiers(unserialized)) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.InvalidUuid,
          message: 'Wrong Security Token Reservation ID format'
        });
      }

      return unserialized;
    }
  }]);

  return SecurityTokenReservation;
}(Entity_1.Entity);

exports.SecurityTokenReservation = SecurityTokenReservation;